export default __webpack_public_path__ + "static/media/Lærervejledning-5-6.b102a62f.pdf";